import { useAppSelector } from 'hooks/useAppSelector';
import { selectEssentialWorkflowStatus } from 'routes/essential-workspace/state/form.selectors';

import { QuoteBadge } from './badge';
import { QuoteChip } from './chip';
import { QuoteIcon } from './icon';

type QuoteStatusProps = {
  variant: 'icon' | 'chip' | 'badge';
  formId: string;
  className?: string;
};

export function QuoteStatus({ variant, formId, className }: QuoteStatusProps) {
  const status = useAppSelector(state => selectEssentialWorkflowStatus(state, formId));

  if (variant === 'badge') {
    return <QuoteBadge formId={formId} status={status} className={className} />;
  }

  if (variant === 'chip') {
    return <QuoteChip status={status} className={className} />;
  }

  return <QuoteIcon status={status} size="lg" className={className} />;
}
